<template>
  <div>
    <b-overlay :show="fetching" spinner-variant="success" spinner-type="grow" rounded="sm">
      <PageWrapper :items="items" :fields="infoFields">
        <div
          v-if="currentLesson.showDescription === false && !toCloseStartButton && !lessonOtherInformation.last_record"
          class="setting-modal"
        >
          <div class="setting-box">
            <div class="confirm-setting" @click="confirmSetting">
              {{ $t('Typing.start') }}
              <br />(Space)
            </div>
          </div>
        </div>
        <template v-slot:content>
          <div class="game-area" ref="game-area">
            <div class="game-area-inner">
              <div class="ball-column" v-for="(ball, index) in ballDataList" :key="index">
                <div
                  class="ball"
                  :style="{ marginTop: (ball.marginTop) + 'px', backgroundColor: ball.color }"
                >{{ ball.character }}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:specialFields>
          <div class="special-field-style">
            <div class="missed">
              <b-row>
                <b-col md="12">
                  <span class="text">{{ $t('Typing.miss') }}</span>
                </b-col>
              </b-row>
              <b-row id="missed-balls">
                <b-col md="3" v-for="i in 10" :key="i" style="margin:0.1rem;">
                  <span
                    :key="i"
                    v-if="missedBalls[i - 1]"
                    :class="[
                    'missed-character',
                    chosenMissedBallIndex === i - 1 ? 'chosen-missed-ball' : null
                  ]"
                    :style="{ backgroundColor: missedBalls[i - 1].color }"
                  >
                    <span>{{ missedBalls[i - 1].character }}</span>
                  </span>
                  <span :key="i" v-else class="missed-character inactive"></span>
                </b-col>
              </b-row>
              <b-tooltip
                ref="missedBallsTooltip"
                target="missed-balls"
                placement="right"
                noninteractive
              >{{ $t('Typing.hitFlashBalls') }}</b-tooltip>
            </div>
          </div>
        </template>

        <template v-slot:other-buttons>
          <b-button
            class="custom-button three"
            style="margin-bottom: 10px"
            @click="showRuleDescriptionModal"
          >{{ $t('Common.ruleDescription') }}</b-button>
          <b-button
            v-show="currentLesson.video_1 && currentLesson.video_1.length > 0"
            class="custom-button three"
            style="margin-bottom: 10px"
            @click="playVideo(currentLesson.video_1)"
          >{{ $t('Typing.playVideo1') }}</b-button>
          <b-button
            v-show="currentLesson.video_2 && currentLesson.video_2.length > 0"
            class="custom-button three"
            style="margin-bottom: 10px"
            @click="playVideo(currentLesson.video_2)"
          >{{ $t('Typing.playVideo2') }}</b-button>
          <b-button
            class="custom-button end-button"
            @click="showAskLeaveModal"
          >{{ $t('Common.endAndLeave') }}</b-button>
        </template>
      </PageWrapper>
    </b-overlay>

    <RemindModal :modalName="'descriptionModal'" modalHeight="200px" ref="descriptionModal">
      <template v-slot:header>
        <span>{{ descriptionModalHeader }}</span>
      </template>
      <template v-slot:body="{ highlight }">
        <div v-html="highlight(descriptionModalBody)"></div>
      </template>
      <template v-slot:buttons>
        <b-row>
          <b-col md="1" sm="0"></b-col>
          <b-col md="10" sm="12">
            <b-button
              class="custom-button four"
              style="width:200px !important;"
              @click="hideDescriptionModal"
            >{{$t('Typing.gotIt')}} (Space)</b-button>
          </b-col>
          <b-col md="1" sm="0"></b-col>
        </b-row>
      </template>
    </RemindModal>

    <RemindModal :modalName="'askLeaveModal'" :modalHeight="'150px'" ref="askLeaveModal">
      <template v-slot:header>
        <span>{{ askLeaveModalHeader }}</span>
      </template>
      <template v-slot:body>
        <p>{{ askLeaveModalBody }}</p>
      </template>
      <template v-slot:buttons>
        <b-row>
          <b-col md="1" sm="0"></b-col>
          <b-col md="5" sm="6">
            <b-button class="custom-button five" @click="endAndLeave">{{$t('Common.yes')}}</b-button>
          </b-col>
          <b-col md="5" sm="6">
            <b-button class="custom-button four" @click="closeAskLeaveModal">{{$t('Common.cancel')}}</b-button>
          </b-col>
          <b-col md="1" sm="0"></b-col>
        </b-row>
      </template>
    </RemindModal>

    <AchievementModal
      :modalName="'lastRecordModal'"
      :modalHeight="'auto'"
      :headerText="lastRecordHeaderText"
      :score="lastRecordDisplayScore"
      :lessonName="items"
      ref="lastRecordModal"
    >
      <template v-slot:buttons>
        <b-row>
          <b-col md="1" sm="0"></b-col>
          <b-col md="10" sm="12">
            <b-button
              class="custom-button four"
              style="width:200px !important;"
              @click="hideLastRecordModal"
            >{{$t('Typing.gotIt')}} (Space)</b-button>
          </b-col>
          <b-col md="1" sm="0"></b-col>
        </b-row>
      </template>
    </AchievementModal>

    <AchievementModal
      :modalName="'scoreModal'"
      :modalHeight="'auto'"
      :headerText="currentRecordHeaderText"
      :score="currentRecordDisplayScore"
      :lessonName="items"
      :extraText="$t('Typing.remindCleaningUp', [missedBalls.length])"
      ref="scoreModal"
    >
      <template v-slot:buttons>
        <b-row>
          <b-col md="1" sm="0"></b-col>
          <b-col md="10" sm="12">
            <b-button
              class="custom-button four"
              style="width:200px !important;"
              @click="closeAndContinueHandler"
            >{{$t('Typing.gotIt')}} (Space)</b-button>
          </b-col>
          <b-col md="1" sm="0"></b-col>
        </b-row>
      </template>
    </AchievementModal>

    <RemindModal
      :modalName="'finalModal'"
      :modalHeight="'auto'"
      :wait="waitForCheckingIfPass"
      ref="finalModal"
    >
      <template v-slot:header>
        <span>{{ finalModalHeader }}</span>
      </template>

      <template v-slot:body="{ highlight }">
        <div v-show="!waitForCheckingIfPass">
          <div v-html="highlight(finalModalMsg1, 20, null, null, 20)"></div>
          <div v-if="pass && currentLesson.lesson_id === 16" v-html="highlight(finalModalMsg2Lesson16, 24, null, null, 24)"></div>
          <div v-else v-html="highlight(finalModalMsg2, 20, null, null, 20)"></div>
          <div v-if="finalModalMsg3.length" v-html="highlight(finalModalMsg3, 20, null, null, 20)"></div>
        </div>
      </template>
      <template v-slot:buttons>
        <b-overlay :show="waitForCheckingIfPass">
          <div>
            <b-row v-if="pass && currentLesson.lesson_id === 16">
              <b-col md='4'>
                <b-button
                  class="custom-button four"
                  @click="backToMenuHandler"
                  style="width: 10rem !important;"
                >{{$t('Common.backToMenu')}}(b)</b-button>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col :md="1"></b-col>
              <b-col v-if="!pass" md="5">
                <b-button
                  class="custom-button four"
                  @click="nextGame"
                  style="width: 10rem !important;"
                >{{$t('Typing.continue')}}(c)</b-button>
              </b-col>
              <b-col v-else md="5">
                <div v-if="[6, 9, 12, 15].includes(currentLesson.lesson_id)">
                  <b-button
                    class="custom-button four"
                    @click="nextCombineLevelHandler"
                  >{{$t('Typing.nextCombineLevel')}}(u)</b-button>
                </div>
                <div v-else>
                  <b-button
                    class="custom-button four"
                    @click="nextLevelHandler"
                    style="width: 180px !important;"
                  >{{$t('Typing.continueToNext')}}(n)</b-button>
                </div>
              </b-col>
              <b-col md='5'>
                <b-button
                  class="custom-button five"
                  @click="backToMenuHandler"
                  style="width: 10rem !important;"
                >{{$t('Common.backToMenu')}}(b)</b-button>
              </b-col>
              <b-col :md="1"></b-col>
            </b-row>
          </div>
        </b-overlay>
      </template>
    </RemindModal>

    <div v-show="toShowVideo" class="video-modal">
      <b-icon icon="x" font-scale="2" @click="closeVideo"></b-icon>
      <b-embed
        type="video"
        aspect="4by3"
        :src="videoUrl"
        style="margin-top:-50px;"
        controls
        controlslist="nodownload"
        allowfullscreen
        autoplay
        oncontextmenu="return false;"
      ></b-embed>
    </div>
  </div>
</template>

<script lang='js'>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import hotkeys from 'hotkeys-js'

import SafeAudio from '@/util/SafeAudio'
import { shuffle, pick, exclude, uniq, getKeys } from '@/util/array.js'

import PageWrapper from '@/components/PageWrapper/PageWrapper.vue'
import RemindModal from '@/components/CustomModal/RemindModal.vue'
import AchievementModal from '@/components/CustomModal/AchievementModal.vue'

const MAX_SPEED = 400
const MIN_SPEED = 90

const BALL_COLOR_LIST = [
  '#3c9eef', '#ff6066', '#c366f2', '#f7d619', '#68d873', '#13a89e', '#ff9d2e'
]
const INITIAL_MARGIN_TOP = -70
const INITIAL_MARGIN_TOP_OFFSET_MULTIPLIER = 0.6
const INITIAL_MARGIN_TOP_RANDOMNESS = 0.4

const TypingSingleAdvanced = Vue.extend({
  name: 'TypingSingleAdvanced',
  props: {
    lessonId: {
      type: [Number, String],
      required: true
    },
    currentLesson: {
      type: Object
    }
  },
  components: {
    PageWrapper,
    RemindModal,
    AchievementModal
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  mounted () {
    if (!this.currentLesson) {
      this.$router.replace({ path: '/typing' })
      return
    } else {
      localStorage.lastTypingActive = '1'
      this.$store.dispatch('typing/fetchLessonOtherInformation', {
        lesson_category: 'single_advanced',
        lesson_id: this.currentLesson.lesson_id
      }).then((response) => {
        if (this.lessonOtherInformation && this.lessonOtherInformation.last_record) {
          this.showLastRecord()
        } else {
          this.showDescription()
        }
      })
    }

    hotkeys('backspace', (e) => {
      e.preventDefault()
    })
    this.updateGameAreaHeight()
    window.addEventListener('resize', this.updateGameAreaHeight)
    window.addEventListener('keydown', this.onKeydown)

    if (this.configured) {
      this.start()
    }
  },
  watch: {
    isRestTime (newValue) {
      if (newValue) {
        this.$store.dispatch('typingAdvanced/stopTimer')
      } else if (this.isGameStart) {
        this.$store.dispatch('typingAdvanced/startTimer')
      }
    },
    checkIfNeedPlayPassSound (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.playPassAudio()
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    window.removeEventListener('beforeunload', this.preventNav)
    if (this.askBeforeLeave) {
      const answer = window.confirm(this.$t('Common.alertLeavingPage'))
      if (answer) {
        this.cleanUpTypingLesson()
        next()
      } else {
        next(false)
      }
    } else {
      this.cleanUpTypingLesson()
      next()
    }
  },
  beforeDestroy () {
    this.$store.dispatch('typingAdvanced/stopTimer')
    window.removeEventListener('resize', this.updateGameAreaHeight)
    window.removeEventListener('keydown', this.onKeydown)
    if (this.requestId) {
      window.cancelAnimationFrame(this.requestId)
    }
    hotkeys.unbind('backspace')
  },
  data () {
    return {
      items: [
        {
          label: this.$t('AppLayout.typingTitle'),
          link: 'typing'
        },
        {
          label: this.$t('Typing.single') + this.$t('Typing.practice'),
          link: 'typing',
          activeTab: 1
        },
        {
          label: this.$t('Typing.advanced') + this.currentLesson.lesson_name
        }
      ],
      descriptionModalHeader: '',
      descriptionModalBody: '',
      askLeaveModalHeader: '',
      askLeaveModalBody: '',
      finalModalHeader: '',
      finalModalBody: '',
      lastRecordHeaderText: '',
      currentRecordHeaderText: '',
      lastRecordDisplayScore: '',
      currentRecordDisplayScore: '',
      videoUrl: '',
      toShowVideo: false,
      askLeaveModalIsHidden: true,
      lastRecordModalIsHidden: true,
      descriptionModalIsHidden: true,
      scoreModalIsHidden: true,
      finalModalIsHidden: true,
      toCloseStartButton: false,
      numOfDrops: 1,
      speed: 1,
      practiceMinutes: 1, // 0.2,
      timestamp: null,
      currentTime: (new Date()).getTime(),
      gameAreaHeight: null,
      requestId: null,
      ended: false,
      practiceResult: '',
      lastNumOfDrops: 1,
      askBeforeLeave: true,
      ballDataList: [],
      randomMissedBalls: [],
      randomMissedBallIndex: -1,
      notToUploadDuplicate: false,
      previousCharacter: '',
      isGameStart: false
    }
  },
  computed: {
    ...mapState({
      lessonOtherInformation: state => state.typing.lessonOtherInformation,
      fetching: state => state.typing.fetching,
      lesson: state => state.typingAdvanced.lesson,
      configured: state => state.typingAdvanced.configured,
      mode: state => state.typingAdvanced.mode,
      selectedNumOfDrops: state => state.typingAdvanced.numOfDrops,
      selectedSpeed: state => state.typingAdvanced.speed,
      selectedPracticeMinutes: state => state.typingAdvanced.practiceMinutes,
      correctTimes: state => state.typingAdvanced.correctTimes,
      incorrectTimes: state => state.typingAdvanced.incorrectTimes,
      missedTimes: state => state.typingAdvanced.missedTimes,
      totalKeyHit: state => state.typingAdvanced.totalKeyHit,
      missedBalls: state => state.typingAdvanced.missedBalls,
      timeElapsed: state => state.typingAdvanced.timeElapsed,
      continuousNotClearTimes1: state => state.typingAdvanced.continuousNotClearTimes1,
      continuousNotClearTimes2: state => state.typingAdvanced.continuousNotClearTimes2,
      remindRollbackOne: state => state.typingAdvanced.remindRollbackOne,
      remindRollbackTwo: state => state.typingAdvanced.remindRollbackTwo,
      waitForCheckingIfPass: state => state.typingAdvanced.waitForCheckingIfPass,
      isRestTime: state => state.studyOrBreak.isRestTime,
      currentUser: state => state.auth.currentUser
    }),
    ...mapGetters({
      score: 'typingAdvanced/score',
      clearNum: 'typingAdvanced/clearNum'
    }),
    infoFields () {
      return [
        {
          label: this.$t('Typing.remainTime'),
          value: `${this.minute} ${this.$t('Common.minute')} ${this.second} ${this.$t('Common.second')}`
        }
      ]
    },
    timeLeft () {
      if (this.selectedPracticeMinutes && this.timestamp && this.timeElapsed) {
        return this.selectedPracticeMinutes * 60 - (this.timeElapsed / 1000)
      }
      return null
    },
    minute () {
      if (this.timeLeft) {
        return Math.floor((Math.max(0, this.timeLeft / 60))).toString()
      }
      return this.practiceMinutes
    },
    second () {
      if (this.timeLeft) {
        return Math.floor((Math.max(0, this.timeLeft % 60))).toString()
      }
      return 0
    },
    chosenMissedBallIndex () {
      return this.randomMissedBallIndex
    },
    finalModalMsg1 () {
      return this.$t('Typing.noticeClearTimes', [this.clearNum, this.currentLesson.threshold_clear_score])
    },
    finalModalMsg2 () {
      let msg = ''
      if (this.pass) {
        msg = this.$t('Typing.noticeClear')
      } else {
        msg = this.$t('Typing.advancedRemainTimes', [this.currentLesson.threshold_clear_frequency - this.clearNum, this.currentLesson.threshold_clear_score])
      }
      return msg
    },
    finalModalMsg2Lesson16 () {
      return this.$t('Typing.noticeClearAllTypingLessons')
    },
    finalModalMsg3 () {
      let msg = ''
      if (this.pass) {
        const keyLessons = [
          { single: 6, combine: 1, text: this.$t('Typing.middleFinger') },
          { single: 9, combine: 2, text: this.$t('Typing.ringFinger') },
          { single: 12, combine: 3, text: this.$t('Typing.littleFinger') },
          { single: 15, combine: 4, text: this.$t('Typing.thumb') }
        ]
        if (this.isKeyLesson) {
          const targetLesson = keyLessons.filter((each) => each.single === this.currentLesson.lesson_id)[0]
          msg = this.$t('Typing.suggestCombine', [targetLesson.text, targetLesson.combine])
        }
      } else {
        if (this.remindRollbackOne) {
          msg = this.$t('Typing.suggestBack1', [this.continuousNotClearTimes1, this.currentLesson.threshold_rollback_score_one])
        } else if (this.remindRollbackTwo) {
          msg = this.$t('Typing.suggestBack2', [this.continuousNotClearTimes2, this.currentLesson.threshold_rollback_score_two])
        } else {
          msg = this.$t('Typing.noticeContinue')
        }
      }
      return msg
    },
    isKeyLesson () {
      return [6, 9, 12, 15].includes(this.currentLesson.lesson_id)
    },
    pass () {
      return this.clearNum >= this.currentLesson.threshold_clear_frequency
    },
    checkIfNeedPlayPassSound () {
      return !this.finalModalIsHidden && !this.waitForCheckingIfPass && this.pass
    }
  },
  methods: {
    preventNav (event) {
      event.preventDefault()
      event.returnValue = ''
    },
    onKeydown (event) {
      if (event.repeat || this.isRestTime) {
        return
      }
      if ((!this.descriptionModalIsHidden || !this.toCloseStartButton) && this.lastRecordModalIsHidden) { // 說明 modal
        if (event.key === ' ') {
          this.hideDescriptionModal()
        }
      } else if (!this.lastRecordModalIsHidden) {
        if (event.key === ' ') {
          this.hideLastRecordModal()
        }
      } else if (!this.scoreModalIsHidden) { // 完成1分鐘接球
        if (event.key === ' ') {
          this.closeAndContinueHandler()
        }
      } else if (!this.finalModalIsHidden && !this.waitForCheckingIfPass) { // 完成清球後的最後 modal
        if (event.key === 'n' && this.pass && this.currentLesson.lesson_id !== 16) {
          this.nextLevelHandler()
        } else if (event.key === 'b') {
          this.backToMenuHandler()
        } else if (event.key === 'c' && this.currentLesson.lesson_id !== 16) {
          this.nextGame()
        } else if (event.key === 'u' && this.isKeyLesson && this.pass && this.currentLesson.lesson_id !== 16) {
          this.nextCombineLevelHandler()
        }
      } else { // 把錯過的球清空
        if (this.configured && !this.ended && event.key.length === 1) {
          this.inputText(event)
        }
        if (this.ended && this.scoreModalIsHidden && event.key.length === 1) {
          this.patchMissedBall(event)
        }
      }
    },
    showDescription () {
      console.log(this.currentLesson.showDescription)
      if (!this.currentLesson.showDescription) {
        return
      }

      this.showRuleDescriptionModal()
    },
    showRuleDescriptionModal () {
      let ruleDescription = this.$t(
        'Typing.typingSingleAdvancedLessonDescription', [
          this.currentLesson.threshold_clear_frequency,
          this.currentLesson.threshold_clear_score
        ])

      this.descriptionModalHeader = this.$t('Common.ruleDescription')
      this.descriptionModalBody = ruleDescription
      this.$refs.descriptionModal.showModal()
      this.descriptionModalIsHidden = false
    },
    showLastRecord () {
      if (!this.lessonOtherInformation.last_record) {
        return
      }
      const lastRecord = this.lessonOtherInformation.last_record
      this.lastRecordDisplayScore = this.$t('Typing.welcomeBack')
      this.lastRecordHeaderText = this.$t('Typing.lastRecord')
      const lastRecordFields = [
        {
          label: this.$t('Typing.correctBalls'),
          value: '' + lastRecord.correct
        },
        {
          label: this.$t('Typing.incorrectBalls'),
          value: '' + lastRecord.incorrect
        },
        {
          label: this.$t('Typing.missedBalls'),
          value: '' + lastRecord.miss
        },
        {
          label: this.$t('Common.score'),
          value: '' + lastRecord.score
        }
      ]
      this.$refs.lastRecordModal.showModal(lastRecordFields, true)
      this.lastRecordModalIsHidden = false
    },
    hideDescriptionModal () {
      this.$refs.descriptionModal.closeModal()
      this.descriptionModalIsHidden = true
      this.confirmSetting()
    },
    hideLastRecordModal () {
      this.$refs.lastRecordModal.closeModal()
      this.lastRecordModalIsHidden = true
      this.confirmSetting()
    },
    confirmSetting () {
      if (this.isRestTime) {
        return
      }

      if (!this.configured) {
        this.$store.dispatch('typingAdvanced/configure', {
          numOfDrops: this.numOfDrops,
          speed: this.speed,
          practiceMinutes: this.practiceMinutes
        }).then(() => {
          this.playStartAudio()
          this.notToUploadDuplicate = false
          this.start()
        })
      }
      this.toCloseStartButton = true
    },
    updateGameAreaHeight () {
      this.gameAreaHeight = (this.$refs['game-area']).clientHeight
    },
    generateBall () {
      const speed = MIN_SPEED + ((MAX_SPEED - MIN_SPEED) / 6) * (this.selectedSpeed - 1)

      const colorList = exclude(BALL_COLOR_LIST, this.ballDataList.map(d => d.color))
      const color = pick(colorList)

      const characterList = uniq(this.currentLesson.exercise_string.split(''))
      let character = pick(characterList)
      while (character === this.previousCharacter) {
        character = pick(characterList)
      }
      this.previousCharacter = character

      const minMarginTop = this.ballDataList.length > 0 ? Math.min(...this.ballDataList.map(b => b.marginTop), INITIAL_MARGIN_TOP) : INITIAL_MARGIN_TOP
      let marginTop = minMarginTop - speed * INITIAL_MARGIN_TOP_OFFSET_MULTIPLIER * (1 + (Math.random() - 0.5) * INITIAL_MARGIN_TOP_RANDOMNESS)

      return {
        color,
        speed,
        marginTop,
        character
      }
    },
    start () {
      this.isGameStart = true
      this.timestamp = performance.now()
      this.ballDataList = []

      Array.from(getKeys(Array(this.selectedNumOfDrops))).forEach(() => {
        this.ballDataList.push(this.generateBall())
      })
      this.ballDataList = shuffle(this.ballDataList)

      this.$store.dispatch('typingAdvanced/startTimer')

      this.requestId = window.requestAnimationFrame(this.step)
    },
    inputText (event) {
      this.$store.dispatch('typingAdvanced/hitKey')
      const ballList = this.ballDataList.filter(b => b.character === event.key && b.marginTop > -35).sort((b1, b2) => b2.marginTop - b1.marginTop)
      if (ballList.length > 0) {
        const i = this.ballDataList.indexOf(ballList[0])
        this.$store.dispatch('typingAdvanced/correct')
        this.playHitSound()
        Vue.set(this.ballDataList, i, this.generateBall())
      } else {
        this.playWrongKeySound()
        const ballList2 = this.ballDataList.sort((b1, b2) => b2.marginTop - b1.marginTop)
        const i = this.ballDataList.indexOf(ballList2[0])
        this.$store.dispatch('typingAdvanced/wrong', { ball: ballList2[0] })
        Vue.set(this.ballDataList, i, this.generateBall())
      }
    },
    step (timestamp) {
      if (this.ended) {
        return
      }
      if (this.isRestTime) {
        this.timestamp = timestamp
        this.requestId = window.requestAnimationFrame(this.step)
        return
      }
      this.exitIfEnded()

      const increment = (timestamp - this.timestamp) / 1000
      this.ballDataList.forEach((ball, i) => {
        ball.marginTop += ball.speed * increment
        if (ball.marginTop > this.gameAreaHeight) {
          this.$store.dispatch('typingAdvanced/miss', { ball })
          Vue.set(this.ballDataList, i, this.generateBall())
          this.playMissedSound()
        } else {
          Vue.set(this.ballDataList, i, ball)
        }
      })

      if (this.lastNumOfDrops < this.selectedNumOfDrops) {
        Array.from(getKeys(Array(this.selectedNumOfDrops - this.lastNumOfDrops))).forEach(() => {
          this.ballDataList.push(this.generateBall())
        })
        this.lastNumOfDrops = this.selectedNumOfDrops
      } else if (this.lastNumOfDrops > this.selectedNumOfDrops) {
        this.ballDataList = this.ballDataList.slice(0, this.selectedNumOfDrops - this.lastNumOfDrops)
        this.lastNumOfDrops = this.selectedNumOfDrops
      }

      this.timestamp = timestamp
      this.currentTime = (new Date()).getTime()
      this.requestId = window.requestAnimationFrame(this.step)
    },
    exitIfEnded () {
      if (
        this.missedBalls.length >= 10 ||
        (typeof this.timeLeft === 'number' && this.timeLeft <= 0)
      ) {
        this.isGameStart = false
        this.ended = true
        this.ballDataList = []
        this.playGameEndAudio()
        this.$store.dispatch('typingAdvanced/end', {
          category: 'single',
          currentLesson: this.currentLesson,
          notComplete: false
        }).then(() => {
          this.$store.dispatch('typingAdvanced/checkIfPass', {
            category: 'single',
            lesson_id: this.currentLesson.lesson_id,
            threshold_score: this.currentLesson.threshold_clear_score
          })
        })
        this.notToUploadDuplicate = true // 防止打完後按離開又再submit一次結果

        this.currentRecordHeaderText = this.$t('Typing.currentPracticeResult')
        this.currentRecordDisplayScore = this.score.toFixed(1)
        this.$refs.scoreModal.showModal([
          {
            label: this.$t('Typing.correctBalls'),
            value: '' + this.correctTimes
          },
          {
            label: this.$t('Typing.incorrectBalls'),
            value: '' + this.incorrectTimes
          },
          {
            label: this.$t('Typing.missedBalls'),
            value: '' + this.missedTimes
          }
        ])

        this.scoreModalIsHidden = false

        this.randomMissedBall()
        this.nextMissedBall()
      }
    },
    patchMissedBall (event) {
      if (event.key === this.missedBalls[this.randomMissedBallIndex].character) {
        this.playHitSound()
        this.$store.dispatch('typingAdvanced/clearMissedBallFromFront', { index: this.randomMissedBallIndex })
        if (this.missedBalls.filter(x => x !== undefined).length === 0) {
          this.$refs.missedBallsTooltip.$emit('close')
          this.showFinalModal()
        } else {
          this.nextMissedBall()
        }
      } else {
        this.playWrongKeySound()
      }
    },
    randomMissedBall () {
      this.randomMissedBalls = shuffle(Array.from(Array(this.missedBalls.length).keys()))
    },
    nextMissedBall () {
      this.randomMissedBallIndex = this.randomMissedBalls.pop()
    },
    showFinalModal () {
      this.finalModalHeader = this.$t('Common.announce')
      this.$refs.finalModal.showModal()
      this.finalModalIsHidden = false
    },
    showAskLeaveModal () {
      this.askLeaveModalHeader = this.$t('Common.notice')
      this.askLeaveModalBody = this.$t('Common.askLeave')
      this.$refs.askLeaveModal.showModal()
      this.askLeaveModalIsHidden = false
    },
    closeAskLeaveModal () {
      this.$refs.askLeaveModal.closeModal()
      this.askLeaveModalIsHidden = true
    },
    endAndLeave () {
      this.isGameStart = false
      if (this.notToUploadDuplicate || this.totalKeyHit <= 0) {
        this.askBeforeLeave = false
        this.$router.replace({ path: '/typing' })
        // window.location.reload()
      } else {
        this.$store.dispatch('typingAdvanced/end', {
          category: 'single',
          currentLesson: this.currentLesson,
          notComplete: true
        }).then(() => {
          this.askBeforeLeave = false
          this.$router.replace({ path: '/typing' })
          // window.location.reload()
        })
      }
    },
    closeAndContinueHandler () {
      this.$refs.scoreModal.closeModal()
      this.scoreModalIsHidden = true
      if (this.missedBalls.length === 0) {
        this.showFinalModal()
      } else {
        this.$refs.missedBallsTooltip.$emit('open')
      }
    },
    nextLevelHandler () {
      this.askBeforeLeave = false

      if (this.currentLesson.lesson_id === 16) {
        return
      }

      const userGradeCode = Number(this.currentUser.gradeId)
      let nextLessonId = this.currentLesson.lesson_id + 1
      if (userGradeCode > 3 && userGradeCode !== 19 && this.currentLesson.lesson_id !== 15) {
        nextLessonId = this.currentLesson.lesson_id + 3
      }

      this.$store.dispatch('typing/fetchLesson', {
        lesson_category: 'single_basic',
        lesson_id: nextLessonId
      }).then((response) => {
        this.$router.replace({
          name: 'typingSingleBasic',
          params: { lessonId: response.lesson_id, currentLesson: response }
        })
      })
    },
    nextCombineLevelHandler () {
      this.askBeforeLeave = false
      const pairs = [
        { single: 6, combine: 1 }, { single: 9, combine: 2 }, { single: 12, combine: 3 }, { single: 15, combine: 4 }
      ]
      this.$store.dispatch('typing/fetchLesson', {
        lesson_category: 'combine_intermediate',
        lesson_id: pairs.find(lesson => lesson.single === this.currentLesson.lesson_id).combine
      }).then((response) => {
        this.$router.replace({
          name: 'typingCombineIntermediate',
          params: { lessonId: response.lesson_id, currentLesson: response }
        })
      })
    },
    nextGame () {
      this.randomMissedBalls = []
      this.randomMissedBallIndex = -1
      this.$refs.finalModal.closeModal()
      this.finalModalIsHidden = true
      this.ended = false
      this.lastNumOfDrops = 1
      this.$store.dispatch('typingAdvanced/configure', {
        numOfDrops: 1,
        speed: 1,
        practiceMinutes: 1 // 0.2
      }).then(() => {
        this.playStartAudio()
        this.start()
      })
    },
    backToMenuHandler () {
      this.askBeforeLeave = false
      this.$router.replace({ path: '/typing' })
    },
    cleanUpTypingLesson () {
      this.$store.dispatch('typingAdvanced/resetState')
      this.askBeforeLeave = true
      this.descriptionModalIsHidden = true
      this.lastRecordModalIsHidden = true
      this.scoreModalIsHidden = true
      this.finalModalIsHidden = true
      this.notToUploadDuplicate = false
      this.randomMissedBalls = []
      this.randomMissedBallIndex = -1
    },
    playWrongKeySound () {
      const audio = new SafeAudio(require('@/assets/Typing/SoundEffects/typing-advanced-wrong-key.mp3'))
      audio.play()
    },
    playMissedSound () {
      const audio = new SafeAudio(require('@/assets/Typing/SoundEffects/typing-advanced-missed.mp3'))
      audio.play()
    },
    playHitSound () {
      const audio = new SafeAudio(require('@/assets/Typing/SoundEffects/typing-advanced-hit.mp3'))
      audio.play()
    },
    playGameEndAudio () {
      const audio = new SafeAudio(require('@/assets/Typing/SoundEffects/typing-advanced-end.mp3'))
      audio.play()
    },
    playStartAudio () {
      const audio = new SafeAudio(require('@/assets/Typing/SoundEffects/typing-advanced-start.mp3'))
      audio.play()
    },
    playPassAudio () {
      const audio = new SafeAudio(require('@/assets/Typing/SoundEffects/update-best-time.mp3'))
      audio.play()
    },
    playVideo (path) {
      if (path && path.length > 0) {
        this.$store.dispatch('ossUtil/getSignedUrl', { path: path })
          .then((response) => {
            this.videoUrl = response
          })
        this.toShowVideo = true
      }
    },
    closeVideo () {
      this.toShowVideo = false
      this.videoUrl = ''
    }
  }
})

export default TypingSingleAdvanced
</script>

<style lang='scss' scoped>
@import "../styles/typingAdvancedStyles.scss";
</style>
